import { useI18n } from "@/lib/i18n/i18n";
import { fmt } from "@/lib/demo/utils";
import { ORIGIN_LABELS, ORIGIN_SHORT } from "@/lib/i18n/dictInteracciones";

export const OriginBreakdown = ({ byOrigin = {}, testPrefix, dark = false }) => {
  const { t } = useI18n();
  const total = Object.values(byOrigin).reduce((a, b) => a + b, 0);
  return (
    <div className="grid gap-3 sm:grid-cols-4" data-testid={`${testPrefix}-origins`}>
      {[["total", "Total interacciones", total], ...Object.keys(ORIGIN_SHORT).map((o) => [o, ORIGIN_LABELS[o], byOrigin[o] || 0])].map(([id, l, v]) => (
        <div key={id} className={`rounded-2xl p-4 ${dark ? "bg-white/[0.06]" : "bg-slate-50"}`} data-testid={`${testPrefix}-origin-${id}`}>
          <p className={`text-[10px] font-bold uppercase tracking-wider ${dark ? "text-white/50" : "text-slate-400"}`}>{t(l)}</p>
          <p className="mt-1 font-display text-2xl font-bold">{fmt(v)}</p>
        </div>
      ))}
    </div>
  );
};

